import { onBeforeUnmount } from 'vue'

const emitterStack: any[] = []

export default function useAppEmit<T>(emit?: T) {
  if (emit) emitterStack.push(emit)

  onBeforeUnmount(() => {
    if (!emit) return
    const top = emitterStack[emitterStack.length - 1]
    if (top === emit) {
      emitterStack.pop()
      return
    }
    const idx = emitterStack.lastIndexOf(emit)
    if (idx !== -1) emitterStack.splice(idx, 1)
  })

  return {
    appEmit: (...args: any): T | undefined => {
      const current = emitterStack[emitterStack.length - 1]
      if (typeof current === 'function') return current(...args)

      return undefined
    },
  }
}
